/* global axios */
import ApiClient from './ApiClient';

class McpKeys extends ApiClient {
  constructor() {
    super('mcp_keys', { accountScoped: true });
  }

  getAvailableTools() {
    return axios.get(`${this.baseUrl()}/mcp_keys/available_tools`);
  }
}

export default new McpKeys();
